import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import { ConfigurationOntologyForAutomaticValuableConceptCreateRequest, ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import { uniqueId } from 'lodash'
import { Nullable } from '@/shared/types/app.types'
import { initialLocalAutomationValuableConceptsModalState, LocalAutomationValuableConceptsModalState } from '@/modules/configurationModule/detail/automation/valuable-concepts/components/valuable-concepts-modal/configuration-valuable-concepts-modal.model'
import ValuableConceptsModalBasicForm from '@/modules/configurationModule/detail/automation/valuable-concepts/components/valuable-concepts-modal-basic-form/configuration-valuable-concepts-modal-basic-form.vue'
import ValuableConceptsModalRelationships from '@/modules/configurationModule/detail/automation/valuable-concepts/components/valuable-concepts-modal-relationships/valuable-concepts-modal-relationships.vue'

@Component({
    components: {
        ValuableConceptsModalBasicForm,
        ValuableConceptsModalRelationships
    }
})
export default class AutomationValuableConceptsModal extends Vue {
    @Ref() readonly localAutomationValuableConceptsModal!: BModal
    @Prop(String) readonly actionTitle!: string
    @Prop(Number) readonly laboratoryId!: number
    @Emit()
    create(defaultPortionTypeCreate: ConfigurationOntologyForAutomaticValuableConceptCreateRequest): ConfigurationOntologyForAutomaticValuableConceptCreateRequest {
        return defaultPortionTypeCreate
    }

    state: LocalAutomationValuableConceptsModalState
    constructor() {
        super()
        this.state = initialLocalAutomationValuableConceptsModalState()
    }

    get tabsActive(): boolean {
        return !!this.state.selectedRow?.id
    }

    async show(selectedRow: Nullable<ConfigurationOntologyForAutomaticValuableConceptResponse>): Promise<void> {
        this.state = initialLocalAutomationValuableConceptsModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.updateRow(selectedRow)
        }
        this.localAutomationValuableConceptsModal.show()
        this.state.modalUID = uniqueId()
    }

    hide(): void { this.localAutomationValuableConceptsModal.hide() }

    updateRow(selectedRow: Nullable<ConfigurationOntologyForAutomaticValuableConceptResponse>): void {
        this._setSelectedRow(selectedRow)
    }

    private _setSelectedRow(selectedRow: Nullable<ConfigurationOntologyForAutomaticValuableConceptResponse>): void {
        this.state = {
            ...this.state,
            selectedRow
        }
    }
}
